interface EnvironmentInterface {
  production: boolean;
  name: string;
  hostname: string;
  socketUrl: string;
  simulatorURL: string;
  userpilot_token: string;
  ssoHubUrl: string;
  platformUrls: PlatformUrls;
}

interface PlatformUrls {
  ada: string;
  ado: string;
  adm: string;
  adf: string;
}

export let environment: EnvironmentInterface;

export function setEnvironment(envIn: EnvironmentInterface) {
  environment = envIn;
}